import React, { createContext, useContext, useState } from "react";

const FormDataContext = createContext({
  awbNumber: "",
  phoneNumber: "",
  setFormData: () => { },
});

export const useFormData = () => useContext(FormDataContext);

export const FormDataProvider = ({ children }) => {
  const [awbNumber, setAwbNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const setFormData = (data) => {
    setAwbNumber(data.awbNumber);
    setPhoneNumber(data.phoneNumber);
  };

  return (
    <FormDataContext.Provider value={{ awbNumber, phoneNumber, setFormData }}>
      {children}
    </FormDataContext.Provider>
  );
};
